import { Component, Vue } from 'vue-property-decorator';
import { createNamespacedHelpers } from 'vuex';
import { VersionItem } from 'store';
const { mapState } = createNamespacedHelpers('versions');

@Component({
	computed: {
		...mapState({
			options(state: any) {
				return Object.keys(state.versions).map((option) => {
					const version = state.versions[option];

					return {
						...version,
						selected: state.current === version.id
					};
				});
			}
		})
	}
})
export default class NavigationFilter extends Vue {
	handleOptionChange(version: VersionItem): void {
		this.$store.dispatch('versions/setVersion', version);
	}
}
